"use client";

import React from "react";
import { Suspense } from "react";

import PujaCampaignPage from "../puja-campaign-page";
import RedirectLoader from "@/components/pujaCampaign2025/redirectLoader";

export default function SuspenseBoundaryWrapper() {
  return (
    <Suspense fallback={<RedirectLoader />}>
      <PujaCampaignPage />
    </Suspense>
  );
}
